<!------
  @description 左侧导航
  @methods 无
  @param 无
  @special
------>
<template>
  <div class="leftSideBar">
    <div
      class="item"
      :class="{ item_active: activeIndex == index }"
      v-for="(item, index) in itemList"
      :key="index"
      @click="itemBtn(index)"
    >
      {{ item.categoryName }}
    </div>
  </div>
</template>

<script>
var VueScrollTo = require('vue-scrollto')
export default {
  name: 'leftSideBar',
  data () {
    return {
      blackList: [], // 不显示右侧的路由列表
      activeIndex: 0 // 选中下标
    }
  },
  computed: {
    itemList () {
      let list = []
        .concat(this.$store.state.punchout.punchoutCategoryList)
        .slice(0, 7)
      return list
    }
  },
  created () {},
  methods: {
    itemBtn (index) {
      if (this.activeIndex !== index) {
        this.activeIndex = index
        VueScrollTo.scrollTo(`#list${index}`)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.leftSideBar {
  position: fixed;
  top: 200px;
  margin-left: -87px;
  width: 50px;
  background: #fff;
  display: flex;
  justify-content: center;
  flex-direction: column;
  z-index: 999;
  .item {
    width: 100%;
    letter-spacing: 3px;
    text-align: center;
    font-size: 14px;
    color: #666666;
    font-family: PingFangSC, PingFangSC-Regular;
    padding: 8px 0;
    cursor: pointer;
    position: relative;
    margin-bottom: 1px;
    word-break:break-all;
    &::after {
      content: '';
      position: absolute;
      left: 5px;
      bottom: -1px;
      width: 40px;
      height: 1px;
      background: #f2f2f2;
    }
    &::after:last-of-type(1) {
      height: 0;
    }
  }
  .item_active {
    background: #e4393c;
    color: #fff;
  }
}
</style>
